import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'header.ageConfirmationModal.title',
    defaultMessage: 'Age Confirmation',
    description: 'Modal title',
  },
  description: {
    id: 'header.ageConfirmationModal.description',
    defaultMessage: 'I confirm that I am at least 16 years old',
    description: 'Description message',
  },
  errorMessage: {
    id: 'header.ageConfirmationModal.errorMessage',
    defaultMessage: 'Something went wrong',
    description: 'Error text',
  },
  declineMessage: {
    id: 'header.ageConfirmationModal.declineMessage',
    defaultMessage: 'Unfortunately, you are not allowed to continue on this platform.',
    description: 'Message after cline No',
  },
  buttonSubmit: {
    id: 'header.ageConfirmationModal.buttonSubmit',
    defaultMessage: 'Yes',
    description: 'The text for Submit button',
  },
  buttonDecline: {
    id: 'header.ageConfirmationModal.declineButton',
    defaultMessage: 'No',
    description: 'The text for Decline button',
  },
});

export default messages;
